import type { Identifiers } from '@hyundai/shared-lib/edit';
import { DialogTag } from '@pixelgenau/ngx-dialog';

export interface EditSelectContentListDialogData {
    id: Identifiers;
    value: { services: Array<{ id: string; headline: string; copy: string }> };
}

export const EditSelectContentListDialogTag = new DialogTag<EditSelectContentListDialogData>(
    'edit-select-content-list-dialog',
    () => import('./edit-select-content-list.component'),
);
